import { render, staticRenderFns } from "./FormatDocumentType.vue?vue&type=template&id=5cb83bdc&scoped=true"
import script from "./FormatDocumentType.vue?vue&type=script&lang=js"
export * from "./FormatDocumentType.vue?vue&type=script&lang=js"
import style0 from "./FormatDocumentType.vue?vue&type=style&index=0&id=5cb83bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb83bdc",
  null
  
)

export default component.exports